/**
 * Enum labels and server message keys (FE-03 FR-FE03-29/30).
 *
 * - `translateEnum("billing", "late")` → `common:enums.billing.late`; an unknown value is shown raw
 *   and reported once (never a crash).
 * - `translateApiMessage("sites", {key, params, text})` resolves server-provided message keys
 *   (e.g. BE-10 DNS notes) from `<areaNs>:api.<key>`, falling back to the server text.
 */
import { reportOnce } from "../../app/observability";
import type { Namespace } from "../../app/i18n";
import { hasKey, translateKey } from "./errors";

export function reportUnknownEnum(kind: string, value: string): void {
  reportOnce(`enum:${kind}:${value}`, `enum.unknown_value ${kind}=${value}`);
}

export function translateEnum(kind: string, value: string, area?: Namespace): string {
  const keys = [
    area && area !== "common" ? `${area}:enums.${kind}.${value}` : null,
    `common:enums.${kind}.${value}`,
  ];
  for (const key of keys) if (key && hasKey(key)) return translateKey(key);
  reportUnknownEnum(kind, value);
  return value;
}

export interface ApiMessage {
  key: string;
  params?: Record<string, unknown>;
  /** Server text in the request language, used when the key is unknown. */
  text?: string;
}

export function translateApiMessage(area: Namespace, message: ApiMessage): string {
  const key = `${area}:api.${message.key}`;
  if (hasKey(key)) return translateKey(key, message.params);
  return message.text ?? message.key;
}
